import { signal } from '@angular/core';

export interface ToggleSet {
  has(index: number): boolean;
  toggle(index: number): void;
}

// Independent per-index expand/collapse state — several indices can be open at once.
export function toggleSet(): ToggleSet {
  const expanded = signal<ReadonlySet<number>>(new Set());
  return {
    has: (index: number) => expanded().has(index),
    toggle: (index: number) => {
      expanded.update((current) => {
        const next = new Set(current);
        if (next.has(index)) {
          next.delete(index);
        } else {
          next.add(index);
        }
        return next;
      });
    },
  };
}
